import script from "./SystemReports.vue?vue&type=script&setup=true&lang=js"
export * from "./SystemReports.vue?vue&type=script&setup=true&lang=js"

import "./SystemReports.vue?vue&type=style&index=0&id=10977d74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10977d74"]])

export default __exports__